<div
  class="form-group"
  [ngClass]="{ floatingPlaceholder: floatingPlaceholder }"
>
  <label *ngIf="label">{{ label }}</label>
  <input
    focusBlur
    appFormErrorMsg
    #inputElement
    [ngClass]="{ 'floatPlaceholder-active': !!value }"
    class="form-control"
    (keyup)="onKeyUp($event)"
    [type]="type"
    [placeholder]="placeholder && !floatingPlaceholder ? placeholder : ''"
    [value]="value"
    [disabled]="disabled"
    [readonly]="readonly"
  />
  <span *ngIf="floatingPlaceholder" class="floatingLabel">{{
    placeholder
  }}</span>
  <small *ngIf="description" class="form-text text-muted" id="emailHelp">{{
    description
  }}</small>
</div>
